import { render, staticRenderFns } from "./ChooseClientButton.vue?vue&type=template&id=7927406a&scoped=true&"
import script from "./ChooseClientButton.vue?vue&type=script&lang=ts&"
export * from "./ChooseClientButton.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseClientButton.vue?vue&type=style&index=0&id=7927406a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7927406a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VDivider,VIcon,VListItem,VListItemContent,VListItemTitle})
